module.exports = __webpack_public_path__ + "static/media/lease1_img1.469bee56.jpg";